export class QueryStringService {
	constructor() {}
	public static convertStringToObject(queryString): object | null {
		if (queryString) {
			queryString = queryString.split("&");
			let paramsObject = {};
			queryString.forEach((param) => {
				let paramArray = param.split("=");
				paramsObject[paramArray[0]] = paramArray[1];
			});
			return paramsObject;
		}
		return null;
	}
	public static convertObjectToString(queryObject): string {
		let queries = Object.keys(queryObject);
		let queryString = "?";
		queries.forEach((query, index) => {
			queryString +=
				query +
				"=" +
				queryObject[query] +
				(index + 1 < queries.length ? "&" : "");
		});
		return queryString;
	}
}
